module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "news-top-right.e2c39f32.jpeg" + "?" + Date.now();